import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgStartShineALine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M6 2.001a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2H7v2a1 1 0 0 1-2 0v-2H3a1 1 0 1 1 0-2h2V3a1 1 0 0 1 1-1M13.5 5a1 1 0 0 1 .972.765c.468 1.937 1.234 3.383 2.307 4.456s2.52 1.84 4.456 2.307a1 1 0 0 1 0 1.944c-1.937.468-3.383 1.234-4.456 2.307s-1.84 2.52-2.307 4.456a1 1 0 0 1-1.944 0c-.468-1.937-1.234-3.383-2.307-4.456s-2.52-1.84-4.456-2.307a1 1 0 0 1 0-1.944c1.937-.468 3.383-1.234 4.456-2.307s1.84-2.52 2.307-4.456A1 1 0 0 1 13.5 5m-4.506 8.5a9.8 9.8 0 0 1 2.641 1.865 9.8 9.8 0 0 1 1.865 2.64 9.8 9.8 0 0 1 1.865-2.64 9.8 9.8 0 0 1 2.64-1.865 9.8 9.8 0 0 1-2.64-1.865 9.8 9.8 0 0 1-1.865-2.64 9.8 9.8 0 0 1-1.865 2.64 9.8 9.8 0 0 1-2.64 1.865'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgStartShineALine)
export default ForwardRef
